export async function getTwitchStreams(bearer: string) {
  const response = await fetch(`https://api.twitch.tv/helix/streams?first=50`, {
    method: "GET",
    headers: {
      "Client-ID": "eo09uxd52vln7jis3a4ownnx0skq1k",
      Authorization: "bearer " + bearer,
    },
  });
  const data = await response.json();

  return data.data;
}
